module.exports = __webpack_public_path__ + "static/media/digitalImg.de99d997.svg";